// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.replaceConfModal__PauBj {
  width: 372px;
  height: 464px;
}

.modalBody__qLowz {
  padding: 25px 25px 0 25px;
}

.modalTitle__PTTlN {
  color: var(--header-title-main);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
  margin: unset;
}

.modalDescr__Hlpym {
  height: 165px;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: var(--tables-secondary-row-sub-title-text);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
.modalDescr__Hlpym p {
  margin: unset;
}

.link__sYzb6 {
  font-size: 14px;
  font-weight: 500;
  color: var(--buttons-surface);
  text-decoration: none;
}

.modalFooter__MxGNn {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 0 51px 35px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ReplaceC1D1SensorConfirmModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,yBAAA;AAzEF;;AA4EA;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iDAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEF;AA2EE;EACE,aAAA;AAzEJ;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.replaceConfModal {\n  width: 372px;\n  height: 464px;\n}\n\n.modalBody {\n  padding: 25px 25px 0 25px;\n}\n\n.modalTitle {\n  color: var(--header-title-main);\n  text-align: center;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n  margin: unset;\n}\n\n.modalDescr {\n  height: 165px;\n  margin-top: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n\n  p {\n    margin: unset;\n  }\n}\n\n.link {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--buttons-surface);\n  text-decoration: none;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 0 51px 35px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"replaceConfModal": `replaceConfModal__PauBj`,
	"modalBody": `modalBody__qLowz`,
	"modalTitle": `modalTitle__PTTlN`,
	"modalDescr": `modalDescr__Hlpym`,
	"link": `link__sYzb6`,
	"modalFooter": `modalFooter__MxGNn`
};
module.exports = ___CSS_LOADER_EXPORT___;
